import FieldForm from "../FieldForm";
import styles from "../Overlay/Overlay.module.css";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { useState, useMemo } from "react";
import HeaderForm from "../HeaderForm";
import Overlay from "../Overlay";
import ButtonForm from "../ButtonForm";
import LabelRequired from "../LabelRequired";
import FieldFormRequired from "../FieldFormRequired";


function FormUser({ setIsOpen }) {
    const [cargo, setCargo] = useState("Líder");
    const [setor, setSetor] = useState("Infraestrutura");
    const [email, setEmail] = useState("");
    const [nome, setNome] = useState("");
    const [senha, setSenha] = useState("");


    const regras = useMemo(() => ({
        temNumero: /\d/,
        temEspecial: /[@#!$*&]/,
        temMaiuscula: /[A-Z]/,
        temMinuscula: /[a-z]/
    }), []);

    const validacao = useMemo(() => {
        return {
            numero: regras.temNumero.test(senha),
            especial: regras.temEspecial.test(senha),
            maiuscula: regras.temMaiuscula.test(senha),
            minuscula: regras.temMinuscula.test(senha),
            tamanho: senha.length >= 8
        };
    }, [senha, regras]);

    const isValid = Object.values(validacao).every(v => v === true);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!isValid) {
                return toast.error("Senha não cumpre os requisitos necessários");
            }

            const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    Name: nome,
                    Email: email,
                    Departamento: setor,
                    Cargo: cargo,
                    Password: senha

                }),
                credentials: "include"
            });

            const data = await res.json();

            if (!res.ok && data.message.includes("Email") && data.message.includes("taken")) {
                console.log(data);
                return toast.error("Email já existente");
            }


            setIsOpen(false);

            toast.success("Usuário criado com sucesso!")

        } catch (err) {
            console.error(err);
        }
    }


    return (
        <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm
                    title="Novo Usuário"
                    close={() => setIsOpen(false)}
                />
                <FieldFormRequired
                    type="text"
                    placeholder="Digite o nome completo"
                    field="Nome completo"
                    setThing={setNome}
                />
                <FieldFormRequired
                    type="email"
                    placeholder="Digite@email.com"
                    field="Email"
                    setThing={setEmail}
                />
                <div className={styles.containerSelect}>
                    <div className={styles.select}>
                        <LabelRequired>Cargo do Sistema</LabelRequired>
                        <SelectRoot value={cargo} onValueChange={setCargo}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Supervisor">Supervisor</SelectItem>
                                <SelectItem value="Líder">Líder</SelectItem>
                                <SelectItem value="Admin">Admin</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.select}>
                        <LabelRequired>Setor</LabelRequired>
                        <SelectRoot value={setor} onValueChange={setSetor}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Infraestrutura">Infraestrutura</SelectItem>
                                <SelectItem value="Residencial">Residencial</SelectItem>
                                <SelectItem value="Engenharia">Engenharia</SelectItem>
                                <SelectItem value="Diretoria">Diretoria</SelectItem>
                                <SelectItem value="Financeiro">Financeiro</SelectItem>
                                <SelectItem value="Outro">Outro</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                </div>
                <div className={styles.customField}>
                    <LabelRequired>Senha</LabelRequired>
                    <input
                        className={styles.inputPassword}
                        type="password"
                        placeholder="Digite sua senha"
                        field="Senha"
                        onChange={(e) => setSenha(e.target.value)}
                        required
                    />
                </div>
                <ul>
                    {validacao.numero ? <li className={styles.true}>A senha precisa conter número</li> : <li className={styles.false}>A senha precisa conter número</li>}
                    {validacao.especial ? <li className={styles.true}>A senha precisa conter caracteres especiais - @#$%&*!</li> : <li className={styles.false}>A senha precisa conter caracteres especiais - @#$%&*!</li>}
                    {validacao.maiuscula ? <li className={styles.true}>A senha precisa conter letra maiúscula</li> : <li className={styles.false}>A senha precisa conter letra maiúscula</li>}
                    {validacao.minuscula ? <li className={styles.true}>A senha precisa conter letra minúscula</li> : <li className={styles.false}>A senha precisa conter letra minúscula</li>}
                    {validacao.tamanho ? <li className={styles.true}>A senha precisa conter no mínimo 8 caracteres</li> : <li className={styles.false}>A senha precisa conter no mínimo 8 caracteres</li>}
                </ul>
                <ButtonForm>Criar Usuário</ButtonForm>
            </form >
        </Overlay>
    )
}


export default FormUser;